// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bb7a023b","594":"f2802e18"}[chunkId] + ".chunk.js";
};